<template>
    <transition name="router-anim">
      <InventoryManagement  v-if="show"></InventoryManagement>
      <InventoryItems v-if="!show" @editAddInv="editAddInv"></InventoryItems>
    </transition>
  </template>
  
  <script>
  import moment from "moment";
  import { mapGetters } from "vuex";
  import { mapActions } from "vuex";
  import InventoryManagement from "../InventoryManagement";
  import InventoryItems from "../InventoryItems";
  
  export default {
    name: "InvButtonCard",
    data(){
      return {
        show: false
      }
    },
    components:{
      InventoryManagement,
      InventoryItems
    },
    methods: {
      ...mapActions([
        'setInvKits',
        'setFillocation',
        'setFilItem',
        'setItems',
        'setRemaining',
        'setInventory'
      ]),
      editAddInv(item){
        this.$emit("editAddInv", {
          show: true,
          item:item,
        });
      },
      showinv(boolean){
        this.setItems();
        this.setFillocation('');
        this.setFilItem('');
        this.setInvKits(boolean);
        this.setRemaining({});
        this.setInventory();

        this.show = boolean;
      },
      // back(){
      //   this.show = false;
      //   this.setItems();
      //   this.setFillocation('');
      //   this.setFilItem('');
      //   this.setInvKits(false);
      //   this.setRemaining({});
      //   this.setInventory();
      // }
      
    },
    computed: {
      ...mapGetters(["getInventory",'getPaginations','getMaxKit','getShowinvkit'])
    },
    watch: {
      getShowinvkit(obj){
        this.showinv(obj);
      }
      // getPaginations(num) {
      //   this.count_page = num;
      // },
      // getMaxKit(num) {
      //   this.maxKits  = num;
      // },
      // getInventory(obj) {
      //   this.inventory = obj;
      // }
    },
    mounted() {
      this.showinv(this.$store.getters.getShowinvkit);
    }
  };
  </script>
  
  <style scoped>
  .kits-title {
    display: flex;
    justify-content: space-between;
    margin: 0 0 30px 0;
    padding: 0 30px;
  }
  .title {
    color: #b3b3b3;
    font-size: 14px;
    font-family: TTNormsMedium, sans-serif;
  }
  .kits-title-header{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-bottom: 30px;
  }
  .title-header {
    color: #005eb8;
    font-size: 20px;
    font-family: TTNormsMedium, sans-serif;
    text-align: center;
  }
  .button-container {
    display: flex;
    justify-content: center;
    align-items: center;
  }

.square-button {
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  border: 1px solid transparent;
  font-size: 24px;
  font-family: TTNormsBold, sans-serif;
  height: 200px;
  margin: 0 0 0 13px;
  cursor: pointer;
  border-radius: 5px;
  
}
.btn-test {
    background-color: #005eb8;
    font-family: TTNormsBold, sans-serif;
    color: #fff;
    width: 300px;
}
.btn-test2 {
    background-color: #43B02A;
    font-family: TTNormsBold, sans-serif;
    color: #fff;
    width: 300px;
}
.state-wrap {
    background-color: #fff;
    padding: 32px 30px;
    margin-bottom: 30px;
    border-radius: 10px;
  }


  </style>
  